import { createSelector } from '@reduxjs/toolkit';

import { diagramSnapshotSelector } from 'src/selectors/diagramSnapshot';
import { hasModelConcepts } from 'src/utils/hasModelConcepts';

// also see hasModelConcepts util fn
export const hasModelConceptsSelector = (projectId: string) =>
  createSelector(diagramSnapshotSelector(projectId), (diagramSnapshot) => {
    if (!diagramSnapshot?.model) {
      return false;
    }

    return hasModelConcepts(diagramSnapshot);
  });
